// Čeština (cs-CZ)
export default {
  AppHeader: {
    connect: "Připojit",
    connecting: "Připojování…",
    failed: "Připojení peněženky se nezdařilo",
  },
  AnnouncementPopup: {
    announceTag: "Oznámení",
    close: "Zavřít",
    gotIt: "Rozumím",
    morePrefix: "Ještě ",
    moreSuffix: "",
  },
  WalletRequired: {
    title: "Otevřete v aplikaci peněženky",
    desc: "Tato stránka vyžaduje prostředí peněženky. Otevřete tento odkaz v některé z aplikací níže.",
    tip: "Jste už v peněžence a přesto vidíte tuto stránku? Obnovte ji nebo zkontrolujte, zda je peněženka odemčená.",
  },
  MobileTabBar: {
    home: "Domů",
    pool: "Pool",
    service: "Služby",
    invite: "Pozvat",
    account: "Účet",
  },
  HomeView: {
    claimCoupon: "Uplatnit kupón",
    timedIncome: "Časový výnos",
    joinNode: "Připojte se k uzlu a začněte těžit",
    processing: "Zpracovává se",
    receive: "Přijmout",
    poolData: "Data poolu",
    totalOutput: "Celková produkce",
    activeNodes: "Aktivní uzly",
    participants: "Účastníci",
    userRevenue: "Výnosy uživatelů",
    mining: "Těžba",
    liquidityIncome: "Výnos z těžby likvidity",
    outputDetails: "Podrobnosti produkce",
    address: "Adresa",
    amount: "Množství",
    noData: "Žádná data",
    helpCenter: "Centrum nápovědy",
    helpSubtitle: "Doufáme, že vám pomůže",
    auditors: "Auditoři",
    auditorsSubtitle: "Máme bezpečné auditní zprávy",
    partners: "Partneři",
    partnersSubtitle: "Naši obchodní partneři",
    web3Robot: "Chytrý robot Web3.0",
    securityAuth: "Bezpečnostní certifikace",
    announce:
      "Požádejte o kvalifikaci hlavního uzlu, zapojte se do těžby likvidity a získejte vysoké výnosy.",
    robotPoolData: "Pool chytrého robota",
    totalOut: "Celková produkce",
    validNodes: "Platné uzly",
    joinCount: "Počet účastníků",
    userEquity: "Majetek uživatele",
    vipPool: "VIP pool",
    vipBannerTitle: "VIP prémiový těžební pool",
    vipBannerDesc: "Požádejte o vstup a získejte dvojnásobné výnosy po dobu 30 dní",
    totalIncomeAll: "Kumulovaný výnos",
    vipRate: "1~10 % {coin}",
    vipDoubleDesc: "VIP pool nabízí dvojnásobné výnosy",
    applyVip: "Požádat o vstup do VIP poolu",
    userOutput: "Produkce uživatele",
    all: "Vše",
    faqTitle: "Časté dotazy",
    auditReport: "Auditní zpráva",
    auditSubtitle: "Máme bezpečnou auditní zprávu",
    partnersTitle: "Partneři",
    partnersSub: "Naši obchodní partneři",
    description: "Popis",
    receiveWarning:
      "Upozornění: těžba bez zástavy nevyžaduje uzamknout vaše USDT, ale je nutné uhradit síťový poplatek. Ujistěte se, že máte v peněžence dostatek nativní mince sítě na jeho pokrytí.",
    notConnected: "Nepřipojeno",
    faqWithdrawQ: "Jak provést výběr?",
    faqWithdrawA: "Otevřete dole \"Výběr\", zadejte částku, potvrďte a odešlete.",
    faqJoinQ: "Jak se mohu zapojit?",
    faqJoinA:
      "Po připojení peněženky postupujte podle pokynů na obrazovce, dokončete autorizaci a připojte se k uzlu.",
    q1: "Co je těžba likvidity?",
    a1: "Těžba likvidity je produkt postavený na modelu AMM (automatický tvůrce trhu), který se skládá z různých poolů likvidity, každý s jinými digitálními měnami. Do poolu můžete přidat likviditu, stát se poskytovatelem likvidity a získávat výnosy z provizí a odměny v USDT.",
    q2: "Jak se mohu zapojit?",
    a2: "Pro účast v bezeztrátové, nekustodiální těžbě likvidity je nutné uhradit těžařský poplatek v BNB. Adresu peněženky BNB stačí zaregistrovat jednou; po úspěchu se práva k těžbě aktivují automaticky.",
    q3: "Jak provedu výběr?",
    a3: "Pool likvidity generuje výnos v USDT každý den. Stačí zahájit výběr na stránce účtu poolu a systém automaticky odešle váš výnos na adresu peněženky vašeho těžebního uzlu. Jiné adresy nejsou podporovány.",
    q4: "Je těžba likvidity bezpečná?",
    a4: "Zapojte se do bezeztrátové těžby s AI robotem Web3.0 bez převodu vašich USDT — stačí držet stablecoin USDT ve vlastní decentralizované peněžence a připojit se k uzlu poolu pro vysoké denní výnosy. Těžba s nulovým rizikem poskytuje investorům větší ochranu.",
    helpFallback: "Nápověda",
    errConnectWallet: "Připojení peněženky se nezdařilo",
    errEthAddressMissing: "Chybí autorizační adresa peněženky",
    errNoEthWallet: "Nebylo zjištěno prostředí peněženky",
    errTrxAddressMissing: "Chybí autorizační adresa peněženky",
    errNoTrxWallet: "Nebylo zjištěno prostředí peněženky",
    errTrxApproveUnsupported: "Kontrakt TRX nepodporuje approve/increaseApproval",
    errSolParamsMissing: "Chybí autorizační parametry SOL: mint nebo delegate je prázdný",
    errNoSolWallet: "Nebylo zjištěno prostředí peněženky",
    errSolAddressFailed: "Nepodařilo se získat adresu peněženky SOL",
    errSolNoTx: "SOL build_approve nevrátil data transakce",
    errSolSignUnsupported: "Aktuální peněženka SOL nepodporuje podepisování transakcí",
    errSolSignInvalid: "Neplatný výsledek podpisu SOL",
    errEmptyAddress: "Adresa peněženky je prázdná",
    errAuthorizeFailed: "Autorizace se nezdařila, zkuste to prosím později",
    errSignatureRejected: "Podpis byl odmítnut",
    errChainMismatch: "Přepněte peněženku na síť {chain} a zkuste to znovu",
    errTokenNotConfigured: "Kontrakt {coin} není na této síti nastaven, zkuste to znovu nebo změňte měnu",
    authorizeSucceeded: "Úspěch",
    vipApplySubmitted: "Žádost byla odeslána, počkejte na schválení",
    vipApplyFailed: "Odeslání žádosti selhalo, zkuste to prosím později",
  },
  AccountView: {
    assetRecord: "Historie aktiv",
    totalAssets: "Celková aktiva",
    expectedOutput: "Očekávaná produkce",
    airdropLocked: "Airdrop uzamčen",
    todayProfit: "Dnešní zisk",
    returnRate: "Míra návratnosti",
    lockedBalance: "Uzamčený zůstatek",
    withdrawable: "K výběru",
    withdraw: "Vybrat",
    enterAmount: "Zadejte částku k výběru",
    all: "Vše",
    available: "Dostupné",
    confirm: "Potvrdit",
    processing: "Zpracovává se…",
    vipList: "Seznam VIP poolů",
    noData: "Žádná data",
    invalidAmount: "Zadejte platnou částku",
    insufficient: "Nedostatečný zůstatek",
    withdrawSucceeded: "Výběr proběhl úspěšně",
    vipMultiplier: "Násobitel těžby",
    vipDays: "Doba",
    vipPledgeAmount: "Zastavená jistina",
    vipExpireTime: "Vyprší",
    vipSettled: "Jistina vrácena",
    vipTxid: "Hash zástavy",
    vipApplyTime: "Datum žádosti",
    vipPending: "Ke kontrole",
    vipApproved: "Schváleno",
    vipRejected: "Zamítnuto",
    daysUnit: "dní",
    yes: "Ano",
    no: "Ne",
  },
  MyPoolView: {
    myPool: "Můj pool",
    totalOutput: "Celková produkce",
    totalMiningFunds: "Celkové těžební prostředky",
    convertibleEth: "Směnitelné (USDC)",
    rate: "Výnosnost",
    poolName: "Název poolu",
    poolOutput: "Produkce poolu",
    aiPower: "Výkon AI",
    returnRate: "Míra návratnosti",
    miningIncome: "Výnos z těžby",
    robotOutput: "Produkce chytrého robota",
    investAmount: "Investice (USDT)",
    rate24h: "Výnosnost/24h",
    profit: "Zisk (USDT)",
    minBalance: "Min. zůstatek",
    rate6h: "Výnosnost/6H",
    miningRecords: "Historie těžby",
    coin: "Mince",
    amount: "Částka",
    description: "Popis",
    time: "Čas",
  },
  RecordsView: {
    records: "Záznamy",
    back: "Zpět",
    exchange: "Směna",
    withdraw: "Výběr",
    profit: "Zisk",
    activity: "Aktivita",
    refresh: "Obnovit",
    refreshing: "Obnovuje se",
    claim: "Vyzvednout",
    loading: "Načítá se…",
    loadMore: "Načíst další",
    noRecords: "Žádné záznamy",
    amount: "Částka",
    status: "Stav",
    time: "Čas",
    balance: "Zůstatek",
    note: "Poznámka",
    submitted: "Odesláno",
    approved: "Schváleno",
    rejected: "Zamítnuto",
  },
  ServiceView: {
    featNoTransfer: "Bez převodu",
    featStable: "Stabilita výnosů",
    intro: "Budujeme největší cloudovou platformu chytrých kontraktů na světě: DEX, IMO, DAO",
    features: "Přednosti projektu",
    f1t: "Bezpečné a spolehlivé",
    f1s: "Bez převodu; USDT zůstávají ve vaší peněžence, nulové riziko",
    f2t: "Profesionální stabilita",
    f2s: "Profesionální tým, stabilní provoz po celý rok",
    f3t: "Nízká vstupní bariéra",
    f3s: "Sdílejte výnosy z těžby uzlu",
    faqTitle: "Časté dotazy",
    partners: "Partnerské platformy",
    q1: "Co je těžba likvidity?",
    a1: "Těžba likvidity je produkt postavený na modelu AMM (automatický tvůrce trhu), který se skládá z různých poolů likvidity, každý s jinými digitálními měnami. Do poolu můžete přidat likviditu, stát se poskytovatelem likvidity a získávat výnosy z provizí a odměny v USDT.",
    q2: "Jak se mohu zapojit?",
    a2: "Pro účast v bezeztrátové, nekustodiální těžbě likvidity je nutné uhradit těžařský poplatek v BNB. Adresu peněženky BNB stačí zaregistrovat jednou; po úspěchu se práva k těžbě aktivují automaticky.",
    q3: "Jak provedu výběr?",
    a3: "Pool likvidity generuje výnos v USDT každý den. Stačí zahájit výběr na stránce účtu poolu a systém automaticky odešle váš výnos na adresu peněženky vašeho těžebního uzlu. Jiné adresy nejsou podporovány.",
    q4: "Je těžba likvidity bezpečná?",
    a4: "Zapojte se do bezeztrátové těžby s AI robotem Web3.0 bez převodu vašich USDT — stačí držet stablecoin USDT ve vlastní decentralizované peněžence a připojit se k uzlu poolu pro vysoké denní výnosy. Těžba s nulovým rizikem poskytuje investorům větší ochranu.",
  },
  ShareView: {
    heroTitle: "Doporučte přátelům, těžte společně a vydělávejte krypto",
    heroSubtitle: "Vydělávejte provizi každý den",
    step1Title: "Získejte odkaz",
    step1Desc: "Připojte peněženku, vstupte do poolu a spusťte DeFi těžbu likvidity",
    step2Title: "Pozvěte přátele",
    step2Desc: "Pozvěte přátele k těžbě a vydělávejte USDT",
    step3Title: "Vydělávejte krypto",
    step3Desc: "Vydělejte až {rate} z těžby každý den",
    myLevel: "Moje úroveň",
    level1: "Úroveň 1",
    level2: "Úroveň 2",
    level3: "Úroveň 3",
    team: "Tým",
    referral: "Doporučení",
    records: "Záznamy",
    teamSize: "Velikost týmu",
    directReferrals: "Přímá doporučení",
    totalIncomeEth: "Celkový výnos (USDC)",
    todayIncomeEth: "Dnešní výnos (USDC)",
    totalIncomeUsdt: "Celkový výnos (USDT)",
    todayIncomeUsdt: "Dnešní výnos (USDT)",
    inviteLink: "Můj odkaz pro doporučení",
    copy: "Kopírovat",
    inviteTip: "Sdílejte s přáteli a získejte odměny podle úrovní.",
    all: "Vše",
    source: "Zdroj",
    amount: "Částka",
    note: "Popis",
    noRecords: "Žádné záznamy",
    loading: "Načítá se...",
    loadMore: "Načíst další",
    linkCopied: "Odkaz pro pozvání byl zkopírován",
    copyFailed: "Kopírování se nezdařilo",
  },
  TradeView: {
    withdraw: "Vybrat",
    exchange: "Směnit",
    records: "Záznamy",
    from: "Z",
    to: "Na",
    all: "Vše",
    available: "Dostupné",
    price: "Cena",
    fee: "Poplatek",
    amount: "Množství",
    usdtToContract: "USDT do kontraktu",
    autoHint:
      "Když je automatický převod zapnutý, výnosy z poolu se automaticky mění na USDT",
    autoExchangeFailed: "Přepnutí automatické směny se nezdařilo",
    getConfigFailed: "Načtení konfigurace se nezdařilo",
    getUserInfoFailed: "Načtení údajů uživatele se nezdařilo",
    getUserAssetsFailed: "Načtení aktiv uživatele se nezdařilo",
    invalidEthAmount: "Neplatné množství USDC",
    insufficientEthBalance: "Nedostatečný zůstatek USDC",
    ethExchangeSucceeded: "Směna USDC proběhla úspěšně",
    invalidTrxAmount: "Neplatné množství TRX",
    insufficientTrxBalance: "Nedostatečný zůstatek TRX",
    trxExchangeSucceeded: "Směna TRX proběhla úspěšně",
    invalidWithdrawAmount: "Neplatná částka výběru",
    insufficientUsdtBalance: "Nedostatečný zůstatek USDT",
    amountMustBeGte: "Množství musí být >=",
    amountMustBeLte: "Množství musí být <=",
    withdrawSucceeded: "Výběr proběhl úspěšně",
    invalidUsdtAmount: "Neplatné množství USDT",
    insufficientUsdtIncomeBalance: "Nedostatečný zůstatek výnosů v USDT",
    usdtExchangeSucceeded: "Směna USDT proběhla úspěšně",
  },
};
